import { inject } from '@angular/core';
import { Router, ActivatedRouteSnapshot, CanActivateFn, UrlTree } from '@angular/router';
import { map, take } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { environment } from '@src/environments/environment';

export const legacyRedirectGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const router = inject(Router);
  const http = inject(HttpClient);
  const slug = route.paramMap.get('slug') || route.url[0]?.path;

  if (!slug) return true;

  const slugs = `/assets/tenant-assets/slugs/slugs.json?v=1.0`;

  return http.get<{ slugs: string[] }>(slugs).pipe(
    take(1),
    map(data => {
      const isLegacySlug = data.slugs.includes(slug);
      if (isLegacySlug) {
        let redirectUrl = `${environment.BlogsLink}/${slug}`;
        const queryParams = route.queryParams;
        if (queryParams && Object.keys(queryParams).length > 0) {
          const queryString = new URLSearchParams(queryParams as any).toString();
          redirectUrl += `?${queryString}`;
        }      
        window.location.href = redirectUrl; 
        return false;
      }
      router.navigate(['/error']);
      return false;
    })
  );
};